import { Component, EventEmitter, Output } from '@angular/core';

import { NgxButtonComponent } from '@digipay/ngx-button';
import { NgxCountDownComponent } from '@digipay/ngx-count-down';

@Component({
  selector: 'app-news-no-feed',
  templateUrl: './news-no-feed.component.html',
  styleUrls: ['./news-no-feed.component.scss'],
  imports: [NgxButtonComponent, NgxCountDownComponent],
  standalone: true,
})
export class NewsNoFeedComponent {
  @Output() onRetry = new EventEmitter();
  inProgress = false;

  refetchNews() {
    if (!this.inProgress) {
      this.onRetry.emit();
      this.inProgress = true;
    }
  }

  onTimerStopped() {
    this.inProgress = false;
  }
}
